/**
 * components/WhatsAppButton.js
 * Propósito: Botón flotante de WhatsApp para contacto rápido.
 */

import React, { useState } from 'react';

export default function WhatsAppButton() {
  const [showTooltip, setShowTooltip] = useState(false);
  
  const phoneNumber = '+48694065580';
  const email = 'emmanuelcafu@gmail.com';
  const whatsappLink = `https://wa.me/${phoneNumber.replace(/\+/g, '')}?text=Hola,%20necesito%20ayuda%20con%20URL%20Security%20Analyzer`;
  const emailLink = `mailto:${email}?subject=Consulta sobre URL Security Analyzer`;
  
  return (
    <div style={{
      position: 'fixed',
      bottom: '30px',
      right: '30px',
      zIndex: 9999,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      gap: '10px'
    }}>
      {/* Tooltip con información de contacto */}
      {showTooltip && (
        <div style={{
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.3)',
          borderRadius: '15px',
          padding: '15px 20px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
          minWidth: '250px',
          animation: 'slideIn 0.3s ease-out'
        }}>
          <p style={{ 
            margin: '0 0 10px 0', 
            fontWeight: 'bold', 
            color: '#333',
            fontSize: '14px'
          }}>
            📞 Contáctame
          </p>
          
          <a 
            href={whatsappLink} 
            target="_blank" 
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              color: '#25D366',
              textDecoration: 'none',
              marginBottom: '8px',
              fontSize: '13px',
              transition: 'transform 0.2s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateX(-3px)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateX(0)'}
          >
            <span style={{ fontSize: '18px' }}>💬</span>
            <span>WhatsApp</span>
          </a>
          
          <a 
            href={emailLink}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              color: '#0066cc',
              textDecoration: 'none',
              fontSize: '13px',
              transition: 'transform 0.2s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateX(-3px)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateX(0)'}
          >
            <span style={{ fontSize: '18px' }}>📧</span>
            <span>{email}</span>
          </a>
        </div>
      )}
      
      {/* Botón principal de WhatsApp */}
      <button
        onClick={() => window.open(whatsappLink, '_blank')}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        style={{
          width: '60px',
          height: '60px',
          borderRadius: '50%',
          border: 'none',
          background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)',
          color: 'white',
          fontSize: '30px',
          cursor: 'pointer',
          boxShadow: '0 4px 20px rgba(37, 211, 102, 0.4)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 0.3s ease',
          animation: 'pulse 2s infinite'
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.transform = 'scale(1.1)';
          e.currentTarget.style.boxShadow = '0 6px 30px rgba(37, 211, 102, 0.6)';
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.boxShadow = '0 4px 20px rgba(37, 211, 102, 0.4)';
        }}
      >
        <svg 
          viewBox="0 0 32 32" 
          width="32" 
          height="32"
          fill="currentColor"
        >
          <path d="M16 0C7.164 0 0 7.164 0 16c0 2.826.736 5.482 2.016 7.784L.069 31.534l8.036-2.085A15.866 15.866 0 0 0 16 32c8.836 0 16-7.164 16-16S24.836 0 16 0zm0 29.333c-2.44 0-4.76-.661-6.746-1.907l-.484-.291-5.016 1.302 1.341-4.885-.318-.502A13.222 13.222 0 0 1 2.667 16c0-7.364 5.97-13.333 13.333-13.333S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.302-9.976c-.4-.2-2.366-1.167-2.733-1.3-.367-.133-.633-.2-.9.2-.267.4-1.033 1.3-1.267 1.567-.233.267-.467.3-.867.1-.4-.2-1.689-.622-3.217-1.985-1.189-1.061-1.992-2.372-2.225-2.772-.233-.4-.025-.617.175-.816.179-.179.4-.467.6-.7.2-.233.267-.4.4-.667.133-.267.067-.5-.033-.7-.1-.2-.9-2.167-1.233-2.967-.325-.778-.656-.672-.9-.685-.233-.012-.5-.015-.767-.015s-.7.1-1.067.5c-.367.4-1.4 1.367-1.4 3.333s1.433 3.867 1.633 4.133c.2.267 2.826 4.315 6.848 6.052.957.413 1.704.66 2.287.845.961.305 1.836.262 2.527.159.771-.115 2.366-.968 2.7-1.902.333-.935.333-1.735.233-1.902-.1-.167-.367-.267-.767-.467z"/>
        </svg>
      </button>
      
      <style>
        {`
          @keyframes pulse {
            0%, 100% {
              box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);
            }
            50% {
              box-shadow: 0 4px 30px rgba(37, 211, 102, 0.7);
            }
          }
          
          @keyframes slideIn {
            from {
              opacity: 0;
              transform: translateY(10px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
    </div>
  );
}
